<div class="section full-height cmn-flex column">
  <div class="section-header cmn-flex row justify-between align-center relative" (click)="collapsible && toggle()">
    <ng-content select=".form-area-header"></ng-content>
    <span *ngIf="collapsible" class="twisty" [@iconChange]="open"></span>
  </div>
  <div class="section-content relative full-height" [@collapseChange]="!open" [ngClass]="{'closed': !open}">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <ng-content *ngIf="displayContent"></ng-content>
  </div>
</div>
